import React, { Component } from "react";
import "./Section.scss";

class Section extends Component {
  render() {
    return (
      <section id={this.props.hid} className="container flex-column-center">
        <h1 style={this.props.style} className="mb-5">
          <img src={require("../assets/img/title.svg")} className="d-inline-block" alt="" />
          <span className="align-middle mx-2">{this.props.title}</span>
          <img src={require("../assets/img/title.svg")} className="d-inline-block rotation-y-180" alt="" />
        </h1>
        {this.props.children}
      </section>
    );
  }
}

Section.defaultProps = {
  style: {
  }
};

export default Section;
